import { Grid, Box, Select, Typography, MenuItem } from '@mui/material';
import { useSelector } from 'react-redux';
import { useController, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

MenuSelectInput.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  onChangeAdditionalActions: PropTypes.func,
};

export default function MenuSelectInput({ fieldName, fieldAttributes, onChangeAdditionalActions = () => {} }) {
  const { control } = useFormContext();
  const { field } = useController({ name: fieldName, control });
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  const selectedOption = fieldAttributes.options.find((x) => String(x.value) === String(field.value))?.label;

  return (
    <Grid container alignItems="center">
      <Grid item>
        <Box>
          <Select
            variant="standard"
            value={field.value ?? ''}
            onChange={(e) => {
              field.onChange(e.target.value);
              onChangeAdditionalActions();
            }}
            displayEmpty
            disabled={!fieldAttributes.isEditable || isCanceled}
            renderValue={() =>
              selectedOption ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ width: '135px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                  {selectedOption}
                </Typography>
              ) : (
                <Typography variant="body2" sx={{ color: 'lightgray' }}>
                  Choose department
                </Typography>
              )
            }
            MenuProps={{
              sx: {
                '& .MuiMenuItem-root': {
                  fontSize: '0.85rem',
                },
              },
            }}
            sx={{
              fontSize: '0.85rem',
              width: '160px',
              '& .MuiSelect-select': {
                padding: '4px',
                pr: '32px',
              },
            }}
          >
            {fieldAttributes.options?.map((v) => (
              <MenuItem key={v.value} value={v.value}>
                {v.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Grid>
    </Grid>
  );
}
